import { useAuth } from "@/hooks/use-auth";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { User, Shield, Calendar, LogOut } from "lucide-react";

const Dashboard = () => {
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen bg-slate-50 py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 gap-4">
            <div>
              <h1 className="text-3xl font-bold text-slate-900">Mijn Dashboard</h1>
              <p className="text-slate-600">Welkom terug, {user?.username}!</p>
            </div>
            <Button variant="outline" onClick={logout} className="gap-2">
              <LogOut className="h-4 w-4" />
              Uitloggen
            </Button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {/* User Profile Card */}
            <Card className="md:col-span-1 border-slate-200 shadow-sm">
              <CardHeader className="text-center">
                <div className="mx-auto bg-amber-100 p-4 rounded-full w-20 h-20 flex items-center justify-center mb-4">
                  <User className="h-10 w-10 text-amber-600" />
                </div>
                <CardTitle>{user?.username}</CardTitle>
                <CardDescription>{user?.email || 'Geen e-mailadres'}</CardDescription>
              </CardHeader>
              <CardContent className="space-y-4">
                <div className="flex items-center gap-3 text-sm text-slate-600">
                  <Shield className="h-4 w-4 text-slate-400" />
                  <span className="capitalize">Rol: {user?.role || 'Gebruiker'}</span>
                </div>
                <div className="flex items-center gap-3 text-sm text-slate-600">
                  <Calendar className="h-4 w-4 text-slate-400" />
                  <span>Lid sinds: {user?.joinDate ? new Date(user.joinDate).toLocaleDateString() : 'Onbekend'}</span>
                </div>
              </CardContent>
            </Card>

            {/* Main Content Area */}
            <Card className="md:col-span-2 border-slate-200 shadow-sm">
              <CardHeader>
                <CardTitle>Recente Activiteit</CardTitle>
                <CardDescription>Overzicht van uw recente acties en status.</CardDescription>
              </CardHeader>
              <CardContent>
                <div className="p-8 text-center text-slate-500 bg-slate-50 rounded-lg border border-dashed border-slate-200">
                  <p>Er zijn nog geen recente activiteiten om weer te geven.</p>
                  <Button className="mt-4 bg-amber-500 hover:bg-amber-600 text-slate-900">
                    Nieuwe aanvraag starten
                  </Button>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
